
export let endpoint = `http://64.227.158.225:8001/`;
export let apiEndPoint = `${endpoint}/api`;
export let imageEndpoint =   `${endpoint}/media/`;
export let APP_ENV = "production";
export function updateEnv(e) {
    APP_ENV = e
    if(e == "qa"){
        endpoint = `http://64.227.158.225:8000/`;
        apiEndPoint = `${endpoint}/api`;
        imageEndpoint =   `${endpoint}/media/`;
    }
    else if(e == "production"){
        endpoint = `http://64.227.158.225:8001/`;
        apiEndPoint = `${endpoint}/api`;
        imageEndpoint =   `${endpoint}/media/`;
    }
    localStorage.setItem('env', e)
} 